import { LOCAL__collection_delete } from '@/state/collection/entity/local_collection_delete';
import { LOCAL__grid2d_delete } from '@/state/grid2d/grid2d/LOCAL__grid2d_delete';
import { store } from '@/state/store';
import { local_workspace_child_entity_child_viewer_delete_by_entity_data } from '../child_entity/local_workspace_child_entity_child_viewer_delete_by_entity_data';

export const on_workspace_child_entity_delete_collection = (ids: string[]) => {
  let slice_collections = store.getState().slice_collections;

  for (let id of ids) {
    let collection = slice_collections.collections_map.get(id);

    //could be null if user is still not received collections during auth
    if (!collection) continue;

    store.dispatch(local_workspace_child_entity_child_viewer_delete_by_entity_data([{ entity_id: id, entity_type: collection.type }]));

    store.dispatch(LOCAL__grid2d_delete([id]));

    store.dispatch(LOCAL__collection_delete(ids));
  }
};
